import React from 'react'
import Eula from '../eula'

const EulaNl = () => {
    return <Eula languageCode="nl" />
}

export default EulaNl
